import { render, staticRenderFns } from "./OrderStatusAssemblyIcon.vue?vue&type=template&id=e46b7404&scoped=true&"
import script from "./OrderStatusAssemblyIcon.vue?vue&type=script&lang=js&"
export * from "./OrderStatusAssemblyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46b7404",
  null
  
)

export default component.exports